var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418 716q24 24 62 23t56-27l239-351-351 239q-26 18-28 55t22 61ZM193 918q-24 0-45.5-11T115 874q-28-50-42.5-104.5T58 657q0-88 33-165t89.5-134q56.5-57 133-91T478 233q89 0 165.5 33T778 356.5Q836 414 869.5 491T903 657q0 58-14 113t-41 104q-15 22-35 33t-44 11H193Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/speed_FILL1_wght700_GRAD200_opsz48.dc0896aa7477caf870108952ea026d31.svg";
export { ForwardRef as ReactComponent };